var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons103(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9679 20.0121C15.4468 20.0121 15.835 19.6243 15.835 19.1451V1.82275C15.835 1.34351 15.4468 0.95575 14.9679 0.95575C14.4886 0.95575 14.1009 1.34351 14.1009 1.82275V19.1451C14.1009 19.6243 14.4886 20.0121 14.9679 20.0121Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4898 7.23436C20.0457 7.05597 19.5415 7.26721 19.3608 7.71131C19.1824 8.1554 19.3941 8.65994 19.8382 8.84022C24.7724 10.84 27.9592 15.5648 27.9592 20.8792C27.9592 28.044 22.1308 33.8706 14.9679 33.8706C7.8049 33.8706 1.97654 28.0422 1.97654 20.8792C1.97654 15.5648 5.16341 10.84 10.0976 8.84022C10.5417 8.66183 10.7534 8.1554 10.5746 7.71131C10.3943 7.26721 9.8863 7.05597 9.44598 7.23436C3.85606 9.49981 0.244385 14.8546 0.244385 20.8792C0.244385 28.9984 6.84871 35.6042 14.9698 35.6042C23.0908 35.6042 29.6948 29.0003 29.6948 20.8792C29.6929 14.8546 26.0797 9.49981 20.4898 7.23436Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons103);
export default __webpack_public_path__ + "static/media/Icons-103.4aa50ce2460515d1d41b420a63a961a4.svg";
export { ForwardRef as ReactComponent };